const mockWeatherData = {
  location: 'New York, US',
  current: {
      data: [{
          country_code: 'GB',
          city_name: 'London',
          temp: 22.5,
          app_temp: 21.2,
          rh: 78,
          pres: 1015,
          vis: 10000,
          wind_spd: 7.2,
          wind_dir: 45,
          sunrise: '07:00',
          sunset: '19:00',
          uv: 3.5,
          aqi: 50,
          precip: 0.5,
          weather: {
              description: "Partly Cloudy",
              icon: "c02d"
          }
      }]
  },
  hourly: {
      data: [
          { time: '10:00', temp: 20.3 },
          { time: '11:00', temp: 21.8 },
          { time: '12:00', temp: 23.1 },
          { time: '13:00', temp: 24.1 },
          { time: '14:00', temp: 25.1 },
          { time: '15:00', temp: 26.1 },
          { time: '16:00', temp: 27.1 },
          { time: '17:00', temp: 28.1 },
          { time: '18:00', temp: 29.1 },
          { time: '19:00', temp: 28.1 },
          { time: '20:00', temp: 27.1 },
          { time: '21:00', temp: 26.1 },
          { time: '22:00', temp: 25.1 },
          { time: '23:00', temp: 24.1 },
          { time: '00:00', temp: 23.1 },
          { time: '01:00', temp: 22.1 },
          { time: '02:00', temp: 21.1 },
          { time: '03:00', temp: 20.1 },
          { time: '04:00', temp: 21.1 },
          { time: '05:00', temp: 22.1 },
          { time: '06:00', temp: 23.1 },
          { time: '07:00', temp: 24.1 },
          { time: '08:00', temp: 25.1 },
          { time: '09:00', temp: 26.1 }
      ]
  },
  daily: {
      data: [
        { 
          valid_date: '2023-09-14',
          wind_spd: 3.1,
          wind_dir:45,
          temp: 22.5,
          max_temp: 25.6,
          min_temp: 20.4,
          high_temp: 26.5,
          low_temp: 19.5,
          app_max_temp: 25.5,
          app_min_temp: 19.0,
          pop: 10,
          precip: 0.9,
          snow: 0,
          snow_depth: 0,
          slp: 1015,
          pres: 1003.5,
          dewpt: 17.8,
          rh: 70.2,
          weather: {
            icon: 'c04d',
            code: '804',
            description: 'Cloudy with showers'
          },
          clouds_low: 30,
          clouds_mid: 75,
          clouds_hi: 45,
          clouds: 80,
          vis: 9,
          max_dhi: 160,
          uv: 3,
          moon_phase: 0.75,
          moon_phase_lunation: 0.35,
          moonrise_ts: 1660671260,
          moonset_ts: 1660681260,
          sunrise_ts: 1660651260,
          sunset_ts: 1660721260
        },
        { 
          valid_date: '2023-09-15',
          wind_spd: 6.4,
          wind_dir:90,
          temp: 23.0,
          max_temp: 26.5,
          min_temp: 21.5,
          high_temp: 27.0,
          low_temp: 20.5,
          app_max_temp: 26.8,
          app_min_temp: 20.0,
          pop: 5,
          precip: 0.27,
          snow: 0,
          snow_depth: 0,
          slp: 1018,
          pres: 1004.5,
          dewpt: 18.3,
          rh: 72.5,
          weather: {
            icon: 'c02d',
            code: '802',
            description: 'Partly cloudy'
          },
          clouds_low: 20,
          clouds_mid: 60,
          clouds_hi: 30,
          clouds: 50,
          vis: 10,
          max_dhi: 168,
          uv: 4,
          moon_phase: 0.85,
          moon_phase_lunation: 0.45,
          moonrise_ts: 1660751260,
          moonset_ts: 1660761260,
          sunrise_ts: 1660731260,
          sunset_ts: 1660801260
        },
        { 
          valid_date: '2023-09-16',
          wind_spd: 2.1,
          wind_dir:270,
          temp: 24.0,
          max_temp: 27.5,
          min_temp: 22.0,
          high_temp: 28.0,
          low_temp: 21.0,
          app_max_temp: 27.2,
          app_min_temp: 20.5,
          pop: 20,
          precip: 0.45,
          snow: 0,
          snow_depth: 0,
          slp: 1016,
          pres: 1003.0,
          dewpt: 19.0,
          rh: 75.0,
          weather: {
            icon: 'c02d',
            code: '802',
            description: 'Light rain showers'
          },
          clouds_low: 40,
          clouds_mid: 70,
          clouds_hi: 50,
          clouds: 60,
          vis: 8,
          max_dhi: 172,
          uv: 3,
          moon_phase: 0.65,
          moon_phase_lunation: 0.25,
          moonrise_ts: 1660841260,
          moonset_ts: 1660851260,
          sunrise_ts: 1660811260,
          sunset_ts: 1660881260
        },
        { 
          valid_date: '2023-09-17',
          wind_spd: 1.9,
          wind_dir:0,
          temp: 22.8,
          max_temp: 26.0,
          min_temp: 20.5,
          high_temp: 27.0,
          low_temp: 20.0,
          app_max_temp: 26.5,
          app_min_temp: 19.8,
          pop: 15,
          precip: 0.08,
          snow: 0,
          snow_depth: 0,
          slp: 1014,
          pres: 1002.5,
          dewpt: 17.2,
          rh: 68.0,
          weather: {
            icon: 'c01d',
            code: '801',
            description: 'Clear sky'
          },
          clouds_low: 10,
          clouds_mid: 50,
          clouds_hi: 20,
          clouds: 30,
          vis: 10,
          max_dhi: 170,
          uv: 3,
          moon_phase: 0.75,
          moon_phase_lunation: 0.35,
          moonrise_ts: 1660921260,
          moonset_ts: 1660931260,
          sunrise_ts: 1660901260,
          sunset_ts: 1660971260
        },
        { 
          valid_date: '2023-09-18',
          wind_spd: 2.5,
          wind_dir: 180,
          temp: 22.8,
          max_temp: 26.0,
          min_temp: 20.5,
          high_temp: 27.0,
          low_temp: 20.0,
          app_max_temp: 26.5,
          app_min_temp: 19.8,
          pop: 15,
          precip: 0,
          snow: 0,
          snow_depth: 0,
          slp: 1014,
          pres: 1002.5,
          dewpt: 17.2,
          rh: 68.0,
          weather: {
            icon: 'c01d',
            code: '801',
            description: 'Clear sky'
          },
          clouds_low: 10,
          clouds_mid: 50,
          clouds_hi: 20,
          clouds: 30,
          vis: 10,
          max_dhi: 170,
          uv: 3,
          moon_phase: 0.75,
          moon_phase_lunation: 0.35,
          moonrise_ts: 1660921260,
          moonset_ts: 1660931260,
          sunrise_ts: 1660901260,
          sunset_ts: 1660971260
        },
        { 
          valid_date: '2023-09-19',
          wind_spd: 2.1,
          wind_dir: 270,
          temp: 22.8,
          max_temp: 26.0,
          min_temp: 20.5,
          high_temp: 27.0,
          low_temp: 20.0,
          app_max_temp: 26.5,
          app_min_temp: 19.8,
          pop: 15,
          precip: 0.5,
          snow: 0,
          snow_depth: 0,
          slp: 1014,
          pres: 1002.5,
          dewpt: 17.2,
          rh: 68.0,
          weather: {
            icon: 'c01d',
            code: '801',
            description: 'Clear sky'
          },
          clouds_low: 10,
          clouds_mid: 50,
          clouds_hi: 20,
          clouds: 30,
          vis: 10,
          max_dhi: 170,
          uv: 3,
          moon_phase: 0.75,
          moon_phase_lunation: 0.35,
          moonrise_ts: 1660921260,
          moonset_ts: 1660931260,
          sunrise_ts: 1660901260,
          sunset_ts: 1660971260
        },
        { 
          valid_date: '2023-09-20',
          wind_spd: 3.6,
          wind_dir:45,
          temp: 22.8,
          max_temp: 26.0,
          min_temp: 20.5,
          high_temp: 27.0,
          low_temp: 20.0,
          app_max_temp: 26.5,
          app_min_temp: 19.8,
          pop: 15,
          precip: 0.5,
          snow: 0,
          snow_depth: 0,
          slp: 1014,
          pres: 1002.5,
          dewpt: 17.2,
          rh: 68.0,
          weather: {
            icon: 'c01d',
            code: '801',
            description: 'Clear sky'
          },
          clouds_low: 10,
          clouds_mid: 50,
          clouds_hi: 20,
          clouds: 30,
          vis: 10,
          max_dhi: 170,
          uv: 3,
          moon_phase: 0.75,
          moon_phase_lunation: 0.35,
          moonrise_ts: 1660921260,
          moonset_ts: 1660931260,
          sunrise_ts: 1660901260,
          sunset_ts: 1660971260
        },
        { 
          valid_date: '2023-09-21',
          wind_spd: 2.2,
          wind_dir:180,
          temp: 22.8,
          max_temp: 26.0,
          min_temp: 20.5,
          high_temp: 27.0,
          low_temp: 20.0,
          app_max_temp: 26.5,
          app_min_temp: 19.8,
          pop: 15,
          precip: 0.5,
          snow: 0,
          snow_depth: 0,
          slp: 1014,
          pres: 1002.5,
          dewpt: 17.2,
          rh: 68.0,
          weather: {
            icon: 'c01d',
            code: '801',
            description: 'Clear sky'
          },
          clouds_low: 10,
          clouds_mid: 50,
          clouds_hi: 20,
          clouds: 30,
          vis: 10,
          max_dhi: 170,
          uv: 3,
          moon_phase: 0.75,
          moon_phase_lunation: 0.35,
          moonrise_ts: 1660921260,
          moonset_ts: 1660931260,
          sunrise_ts: 1660901260,
          sunset_ts: 1660971260
        },
      ],
  }
};

export default mockWeatherData;
